import UserStores from "../../stores/User";

export function getVisitClass (item) {
  let extraClass = 'default-cell-class'
  if (!item.visitors[UserStores.actualUser.id]) {
    extraClass += ' no-visit'
  }
  return extraClass;
}
